import React from 'react';
import { Box, Typography } from '@mui/material';
import { useMCContext } from '../contexts/useMCStates';

const A = 'For Every Moment.';
const B = 'For Every Golfer.';
const C = ' —— ';
const NUM_CYCLES = 16;

export const MarqueeBanner: React.FC = () => {
    const { factor, appTheme } = useMCContext();

    const segments = Array.from({ length: NUM_CYCLES * 4 }, (_, i) => {
        switch (i % 4) {
            case 0: return A;
            case 1: return C;
            case 2: return B;
            default: return C;
        }
    });

    return (
        <Box
            sx={{
                position: 'relative',
                width: '100%',
                overflow: 'hidden',
                backgroundColor: 'white',
                py: 0.75 * factor,
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: 48,
                    height: '100%',
                    background: 'linear-gradient(to right, white, transparent)',
                    zIndex: 1,
                    pointerEvents: 'none',
                },
                '&::after': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    right: 0,
                    width: 48,
                    height: '100%',
                    background: 'linear-gradient(to left, white, transparent)',
                    zIndex: 1,
                    pointerEvents: 'none',
                },
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    gap: 4,
                    width: 'max-content',
                    animation: 'marquee-scroll 24s linear infinite',
                    '@keyframes marquee-scroll': {
                        '0%': { transform: 'translateX(0)' },
                        '100%': { transform: `translateX(-${400 / (NUM_CYCLES * 4)}%)` },
                    },
                }}
            >
                {segments.map((text, i) => (
                    <Typography
                        key={i}
                        variant="subtitle2"
                        sx={{
                            color: appTheme.palette.primary.main,
                            fontWeight: 600,
                            whiteSpace: 'nowrap',
                            letterSpacing: 0.5,
                        }}
                    >
                        {text}
                    </Typography>
                ))}
            </Box>
        </Box>
    );
};
